<template>
    <div>
        
        <a href="" class="back-cta cta-link" @click.prevent="reopenDuplicates" v-if="!this.$route.query.externalId">
            <div class="icon left"><SvgArrowLeft fill="primary"/></div>
            <span>Back</span>
        </a>
                
      
        <h2>Update Candidate Record</h2>
        <hr/>
        <p>The uploaded CV contains new data. Please select the values you wish to retain.</p>

        <div id="diff-select">
            <div class="titles">
                <div class="lhs">
                    <h3>New values (CV)</h3>
                </div>
                <div class="rhs text-right">
                    <h3>Values in Salesforce</h3>
                </div>
            </div>

            <div class="field-list" v-if="diffList">
                <DiffField v-for="(diff, index) in diffList" :key="index" :name="index" />                
            </div>


            <div class="button-container text-right">
                <a href="" class="button" @click.prevent="confirmSelection(false)">Edit</a>
                <a href="" class="button" @click.prevent="confirmSelection(true)">Continue</a>
            </div>

        </div>

    </div>
</template>

<script>

    import DiffField from './DiffField';

    import SvgArrowLeft from '../vue-components/src/components/core/icons/SvgArrowLeft';

    export default {
        name: "Diff",
        components: {DiffField, SvgArrowLeft},
        props: [
            'diffStagedCandidate'
        ],
        computed: {
            stagedCandidateForm() {
                return this.$store.state.cvUpload.stagedCandidateForm;
            },
            diffList() {
                return this.$store.state.cvUpload.stagedCandidateDiff;
            }
        },
        methods: {
            confirmSelection(toggleSendCandidateFlag) {
                this.$store.dispatch('applyStagedCandidateDiffs');
                if(this.diffList.country){
                    this.$store.dispatch('lookup', {type: 'Province', parentId: this.diffList.country[this.diffList.country.selected]});
                }
                if (this.diffStagedCandidate) {
                    this.$store.commit('setStagedCandidateFormField',{field: 'forCandidateId', value: this.diffStagedCandidate.externalId});
                    this.$store.commit('setStagedCandidate', this.diffStagedCandidate);
                }
                if(this.stagedCandidateForm.validate() && toggleSendCandidateFlag){
                    this.$store.dispatch('toggleSendCandidateFlag');
                }
                this.$store.dispatch('closeModal');
            },
            editSelection() {
                this.$store.dispatch('applyStagedCandidateDiffs');
                if(this.diffList.country){
                    this.$store.dispatch('lookup', {type: 'Province', parentId: this.diffList.country[this.diffList.country.selected]});
                }
                if (this.diffStagedCandidate) {
                    this.$store.commit('setStagedCandidateFormField',{field: 'forCandidateId', value: this.diffStagedCandidate.externalId});
                    this.$store.commit('setStagedCandidate', this.diffStagedCandidate);
                }
                if(this.stagedCandidateForm.validate()){
                    this.$store.dispatch('toggleSendCandidateFlag');
                }
                this.$store.dispatch('closeModal');
            },
            reopenDuplicates() {
                this.$store.dispatch('openModal', {
                    componentName: 'DuplicateCandidates',
                    componentProps: {
                    }
                });
            }
        }
    }
</script>

<style scoped>

    .back-cta {margin-bottom: .5rem;}

    #diff-select {margin-top: 2.5rem;}

    .titles {display: flex;}
        .titles > div {width: 50%;}
    
    .field-list {margin-top: 1.5rem;}


</style>